/**
 * BUNKER 84 — tile id constants + classification helpers.
 *
 * Single source of truth for what a tile id means. Used by the
 * level loader, the collision helper, and (in later stories) the
 * raycaster's wall-type lookup.
 */

/** Side length of the level grid in tiles. v0.1 ships a single 32×32 level. */
export const GRID_SIZE = 32;

/**
 * Tile IDs match the LEGEND in level1.ts. Kept as `number` (not enum)
 * because we want to store them in a `Uint8Array` cheaply.
 */
export type TileId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/**
 * Solid for the purposes of v0.1 movement collision. Doors and
 * secret walls are solid here; v0.3 stories add "open / pushed"
 * state that flips specific instances to passable.
 */
export function isSolid(tile: number): boolean {
  return tile !== 0;
}

/**
 * Fetch the tile at integer tile coords. Returns `1` (solid concrete)
 * for any out-of-bounds query so collision pushes the player back
 * inside the map even if the spawn or velocity math glitches.
 */
export function tileAt(map: Uint8Array, tx: number, ty: number): number {
  if (tx < 0 || ty < 0 || tx >= GRID_SIZE || ty >= GRID_SIZE) {
    return 1;
  }
  return map[ty * GRID_SIZE + tx]!;
}
